import { Injectable } from '@angular/core';
import { DefaultService, PsnbUserRolesPermissionConfigResponse, UserDetails } from '@psnb/psnb-api';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserService {
  public constructor(private powerSupplyService: DefaultService) {}

  public getUserDetails(): Observable<UserDetails> {
    return this.powerSupplyService.getUserDetails().pipe(map((result: UserDetails): UserDetails => result));
  }

  public async getUserRolePermissionConfigs(): Promise<PsnbUserRolesPermissionConfigResponse[]> {
    return firstValueFrom(this.powerSupplyService.getUserRolePermissionConfigs());
  }
}
